import React from 'react'
import { Outlet } from 'react-router-dom'

import { useLayout } from '@app/routing/LayoutContext'

import { YearlyKycUpdateDetailsNotification } from '@pages/Profile/YearlyKycUpdateDetails/YearlyKycUpdateDetailsNotification'
import { isKycUpdatePending } from '@pages/Profile/YearlyKycUpdateDetails/YearlyKycUpdateDetailsPage'

import { useAccountReadContext } from '@context/AccountContextContext'

import { isDocumentManagementNotificationNeeded } from '@utils/AccountAccess/accountDocumentStatuses'

import { DocumentManagementNotification } from '../Profile/DocumentManagement/DocumentManagementPage'

export const Dashboard: React.FC = () => {
  const { account } = useAccountReadContext()
  const { hasNotices } = useLayout()

  return (
    <>
      {hasNotices && (
        <>
          {isKycUpdatePending(account) && <YearlyKycUpdateDetailsNotification />}
          {isDocumentManagementNotificationNeeded(account) && <DocumentManagementNotification />}
        </>
      )}
      <Outlet />
    </>
  )
}
